export default {
    init() {
        $(document).on("click", "[data-date-shortcut]", function () {
            const shortcut = $(this);
            const form = shortcut.closest("form");
            const dateInput = form.find("[data-date-shortcut-target]").first();

            dateInput.val(shortcut.data("date-shortcut")).trigger("input").trigger("change");
            form.find("[data-date-shortcut]").removeClass("is-selected");
            shortcut.addClass("is-selected");
        });

        $(document).on("click", "[data-date-range-shortcut]", function () {
            const shortcut = $(this);
            const form = shortcut.closest("form");

            form.find("[data-date-range-start]")
                .val(shortcut.data("date-range-start"))
                .trigger("input")
                .trigger("change");
            form.find("[data-date-range-end]")
                .val(shortcut.data("date-range-end"))
                .trigger("input")
                .trigger("change");

            shortcut.closest(".date-shortcuts").find("[data-date-range-shortcut]").removeClass("is-selected");
            shortcut.addClass("is-selected");
        });
    },
};
